import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import rCoin from "../../assets/images/shell.png";
import calendarIcon from "../../assets/images/calender.png";
import coinsIcon from "../../assets/images/coins.png";
import useTranslation from "../../hooks/useTranslation";

const DailyIncome = () => {
  const { t } = useTranslation();
  const { hostHitory } = useSelector((state) => state.history);
  const navigate = useNavigate();

  const handleOpenHistory = (data) => {
    navigate("/host/historyInfo", { state: data?.date });
  };

  return (
    <div style={{ padding: "16px", maxWidth: "500px", margin: "0 auto" }}>
      {hostHitory?.length > 0 ? (
        hostHitory.map((data, index) => (
          <div
            key={index}
            className="host-list-card"
            style={{
              cursor: "pointer",
            }}
          >
            <div className="host-list-row">
              <span className="host-list-label">
                <span className="host-list-icon">
                  <img
                    src={calendarIcon}
                    alt=""
                    height={16}
                    width={16}
                    style={{ objectFit: "contain" }}
                  />
                </span>
                {t("date")}
              </span>
              <span className="host-list-value">
                {moment(data?.date).format("DD-MM-YYYY")}
              </span>
            </div>
            <div className="host-list-row">
              <span className="host-list-label">
                <span className="host-list-icon">
                  <img
                    src={coinsIcon}
                    alt=""
                    height={16}
                    width={16}
                    style={{ objectFit: "contain" }}
                  />
                </span>
                {t("pay_coin")}
              </span>
              <span className="host-list-value">
                <img src={rCoin} alt="R Coin" height={18} width={20} />
                {data?.totalRCoin ? data?.totalRCoin.toFixed(0) : 0}
              </span>
            </div>
          </div>
        ))
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "rgba(255,255,255,0.55)",
            fontSize: "16px",
            background: "transparent",
            borderRadius: "12px",
          }}
        >
          {t("no_data_found")}
        </div>
      )}
    </div>
  );
};

export default DailyIncome;
